import { renderDateCell, renderNumberCell } from '@/lib/listCells';
import type { CrudConfig } from '@startupquickstart/frontend';

export interface GreaterArea {
  id: string;
  name: string;
  slug: string;
  color?: string | null;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const greaterAreaCrudConfig: CrudConfig<GreaterArea> = {
  entityName: 'Greater Area',
  entityNamePlural: 'Greater Areas',
  endpoints: {
    list: '/greater-areas',
    single: (id: string) => `/greater-areas/${id}`,
    create: '/greater-areas',
    update: (id: string) => `/greater-areas/${id}`,
    delete: (id: string) => `/greater-areas/${id}`,
  },
  fields: [
    {
      key: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      placeholder: 'e.g. Boston',
      validation: { min: 1, max: 120 },
    },
    {
      key: 'slug',
      label: 'Slug',
      type: 'text',
      required: true,
      placeholder: 'e.g. boston',
      helpText: 'Lowercase letters, numbers, and hyphens. Used in URLs/filters.',
    },
    {
      key: 'color',
      label: 'Color',
      type: 'text',
      required: false,
      placeholder: '#1F2937',
    },
    {
      key: 'sortOrder',
      label: 'Sort Order',
      type: 'number',
      required: false,
      defaultValue: 0,
      align: 'right',
      format: renderNumberCell,
    },
    { key: 'createdAt', label: 'Created', type: 'datetime', format: renderDateCell },
    { key: 'updatedAt', label: 'Updated', type: 'datetime', format: renderDateCell },
  ],
  listView: {
    fields: ['name', 'slug', 'sortOrder', 'updatedAt'],
    // Phones keep the two leading columns; the rest is desktop
    // detail (hideOnMobile) so the table never scrolls sideways.
    columns: [
      { field: 'name' },
      { field: 'slug' },
      { field: 'sortOrder', hideOnMobile: true },
      { field: 'updatedAt', hideOnMobile: true },
    ],
    searchableFields: ['name', 'slug'],
    sortableFields: ['name', 'slug', 'sortOrder', 'updatedAt'],
    defaultSort: { field: 'sortOrder', direction: 'asc' },
    itemsPerPage: 25,
    filters: [],
    actions: { create: { enabled: true }, view: { enabled: true }, edit: { enabled: true }, delete: { enabled: true } },
  },
  detailView: {
    sections: [
      {
        title: 'Greater Area',
        description: 'City / region details',
        fields: ['name', 'slug', 'color', 'sortOrder'],
      },
    ],
  },
  form: {
    sections: [
      {
        title: 'Greater Area',
        description: 'A managed city or region that library challenges can belong to.',
        fields: ['name', 'slug', 'color', 'sortOrder'],
        columns: 2,
      },
    ],
  },
};
